import React from 'react';
import { cn } from '../../utils';
interface BadgeProps {
  children: React.ReactNode;
  className?: string;
}
export function Badge({
  children,
  className
}: BadgeProps) {
  return <div className={cn('inline-flex items-center gap-2 border border-gold-500/30 rounded-full px-4 py-1.5 bg-gold-500/5 text-gold-400 text-xs font-bold tracking-widest uppercase', className)} data-id="element-203">
      <span className="w-1.5 h-1.5 rounded-full bg-gold-500 animate-pulse" data-id="element-204" />
      {children}
    </div>;
}